import type { ReportedPost } from '../entities/reported_post.entity'
import type { ReportedPostRepository } from '../repositories/reported_post_repository'

export class ListReportedPostsUseCase {
  constructor(private readonly repository: ReportedPostRepository) {}

  execute(): Promise<ReportedPost[]> {
    return this.repository.list()
  }
}
